"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatBrowserControls = exports.CHAT_BROWSER_CONTROLS_MIN_HEIGHT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ChatTabs_1 = require("./ChatTabs");
const constants_1 = require("../../constants");
exports.CHAT_BROWSER_CONTROLS_MIN_HEIGHT = 132;
const Controls = styled_1.default.div((props) => ({
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    borderBottom: `${constants_1.theme.border.width.thin}px solid ${constants_1.Color.MEDIUM_GREY}`,
    minHeight: props.hasTabs ? exports.CHAT_BROWSER_CONTROLS_MIN_HEIGHT : undefined,
}));
const ChatBrowserControls = (props) => {
    const firstTab = props.tabs?.[0];
    return ((0, jsx_runtime_1.jsxs)(Controls, { hasTabs: !!firstTab, children: [!!props.tabs && !!firstTab && ((0, jsx_runtime_1.jsx)(ChatTabs_1.ChatTabs, { activeTab: props.activeTab ?? firstTab.name, onActivate: props.onTabChange ?? (() => undefined), tabs: props.tabs })), props.children] }));
};
exports.ChatBrowserControls = ChatBrowserControls;
